import AcknowledgementScreen from "./AcknowledgementScreen";

export default AcknowledgementScreen;
